import { SVGProps } from 'react';
const SvgArrowUpLeftMd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M17 17 7 7M7 15V7h8"
    />
  </svg>
);
export default SvgArrowUpLeftMd;
